var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getRepresentativeValue, normalizeName } from '../utils.js';
import { Amount } from './Amount.js';
import { Balance } from './Balance.js';
import { BalancesDataTableBuilder } from '../builders/BalancesDataTableBuilder.js';
/** @internal */
export class AccountBalancesContainer {
    constructor(parent, balancesReport, payload) {
        this.parent = parent;
        this.balancesReport = balancesReport;
        this.payload = payload;
    }
    getBalancesReport() {
        return this.balancesReport;
    }
    getName() {
        return this.payload.name;
    }
    getNormalizedName() {
        return this.payload.normalizedName;
    }
    getGroup() {
        return __awaiter(this, void 0, void 0, function* () {
            return null;
        });
    }
    getAccount() {
        return __awaiter(this, void 0, void 0, function* () {
            const account = yield this.balancesReport.getBook().getAccount(this.getNormalizedName());
            return account || null;
        });
    }
    getParent() {
        return this.parent;
    }
    getDepth() {
        if (this.depth == null) {
            const parent = this.getParent();
            this.depth = parent != null ? parent.getDepth() + 1 : 0;
        }
        return this.depth;
    }
    isCredit() {
        return this.payload.credit;
    }
    isPermanent() {
        return this.payload.permanent || false;
    }
    isFromAccount() {
        return true;
    }
    isFromGroup() {
        return false;
    }
    hasGroupBalances() {
        return false;
    }
    getCumulativeBalance() {
        return getRepresentativeValue(new Amount(this.payload.cumulativeBalance || 0), this.isCredit());
    }
    getCumulativeBalanceRaw() {
        return new Amount(this.payload.cumulativeBalance || 0);
    }
    getCumulativeCredit() {
        return new Amount(this.payload.cumulativeCredit || 0);
    }
    getCumulativeDebit() {
        return new Amount(this.payload.cumulativeDebit || 0);
    }
    getCumulativeBalanceText() {
        return this.balancesReport.getBook().formatValue(this.getCumulativeBalance());
    }
    getCumulativeBalanceRawText() {
        return this.balancesReport.getBook().formatValue(this.getCumulativeBalanceRaw());
    }
    getCumulativeCreditText() {
        return this.balancesReport.getBook().formatValue(this.getCumulativeCredit());
    }
    getCumulativeDebitText() {
        return this.balancesReport.getBook().formatValue(this.getCumulativeDebit());
    }
    getPeriodBalance() {
        return getRepresentativeValue(new Amount(this.payload.periodBalance || 0), this.isCredit());
    }
    getPeriodBalanceRaw() {
        return new Amount(this.payload.periodBalance || 0);
    }
    getPeriodCredit() {
        return new Amount(this.payload.periodCredit || 0);
    }
    getPeriodDebit() {
        return new Amount(this.payload.periodDebit || 0);
    }
    getPeriodBalanceText() {
        return this.balancesReport.getBook().formatValue(this.getPeriodBalance());
    }
    getPeriodBalanceRawText() {
        return this.balancesReport.getBook().formatValue(this.getPeriodBalanceRaw());
    }
    getPeriodCreditText() {
        return this.balancesReport.getBook().formatValue(this.getPeriodCredit());
    }
    getPeriodDebitText() {
        return this.balancesReport.getBook().formatValue(this.getPeriodDebit());
    }
    createDataTable() {
        return new BalancesDataTableBuilder(this.balancesReport.getBook(), [this], this.balancesReport.getPeriodicity());
    }
    getBalancesContainers() {
        return [];
    }
    getBalances() {
        if (!this.payload.balances) {
            return new Array();
        }
        return this.payload.balances.map(balancePlain => new Balance(this, balancePlain));
    }
    getProperties() {
        return this.payload.properties != null ? Object.assign({}, this.payload.properties) : {};
    }
    getProperty(...keys) {
        for (let index = 0; index < keys.length; index++) {
            const key = keys[index];
            let value = this.payload.properties != null ? this.payload.properties[key] : null;
            if (value != null && value.trim() != '') {
                return value;
            }
        }
        return undefined;
    }
    getPropertyKeys() {
        let properties = this.getProperties();
        let propertyKeys = [];
        if (properties) {
            for (var key in properties) {
                if (Object.prototype.hasOwnProperty.call(properties, key)) {
                    propertyKeys.push(key);
                }
            }
        }
        propertyKeys = propertyKeys.sort();
        return propertyKeys;
    }
    getBalancesContainer(name) {
        const normalizedName = normalizeName(name);
        if (this.getNormalizedName() == normalizedName) {
            return this;
        }
        throw `${name} does not match ${this.getName()}`;
    }
}
//# sourceMappingURL=BalancesContainerAccount.js.map